import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AddLendingType, LendingType } from '../models';
import { ClubHubDataService } from './clubhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class LendingTypeService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  private lendingTypeValue!: LendingType;
  lendingTypes!: LendingType[];

  get lendingType() {
    return this.lendingTypeValue;
  }

  set lendingType(val: LendingType) {
    this.lendingTypeValue = val;
  }

  setLendingType(lendingType: LendingType) {
    this.lendingType = lendingType;
  }

  getLendingType(code: string) {
    return this.lendingTypes.find((l) => l.code === code);
  }

  getLendingTypes() {
    return this.clubHubDataService.get<LendingType[]>('lendingtypes').pipe(
      tap((types) => {
        this.lendingTypes = types;
      }),
    );
  }

  addLendingType(model: AddLendingType) {
    return this.clubHubDataService.post('lendingtypes', model);
  }

  updateLendingType(lendingType: LendingType) {
    return this.clubHubDataService.put('lendingtypes', lendingType);
  }

  removeLendingType(lendingTypeId: number) {
    return this.clubHubDataService.delete(`lendingtypes/${lendingTypeId}`);
  }

  uploadLendingTypeLogo(lendingTypeId: number, logo: any) {
    return this.clubHubDataService.post<LendingType>(`lendingtypes/${lendingTypeId}/logo`, logo);
  }

  removeLendingTypeLogo(lendingTypeId: number) {
    return this.clubHubDataService.delete<LendingType>(`lendingtypes/${lendingTypeId}/logo`);
  }
}
